const setTestSeriesReducer = (state = {}, action = {}) => {
    if (action.type === 'CURRENT_TEST_SERIES') {
        return action.payload;
    }
    return state;
};

export default setTestSeriesReducer;
